import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import authService from '../services/authService';
import { useAuth, DEV_AUTH_KEY } from '../../../context/AuthContext';
import { LOGIN_ID_KEY } from '../../../api/axiosClient';
import { isValidVerhoeff } from '../../../utils/verhoeff';
import AppHeader from '../../../components/AppHeader/AppHeader';

const DEV_USERNAME = '100112345676';
const DEV_PASSWORD = 'admin';

function LoginPage() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exiting, setExiting] = useState(false);
  const navigate = useNavigate();
  const { setIsAuthenticated, isAuthenticated, checking } = useAuth();

  const goToDashboard = () => {
    setExiting(true);
    setTimeout(() => {
      navigate('/dashboard', { state: { fromLogin: true } });
    }, 280);
  };

  // GET /auth/auth-me already validated the token when the app booted.
  // If it succeeded, the login process is skipped and the page goes
  // straight to the dashboard.
  useEffect(() => {
    if (!checking && isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [checking, isAuthenticated, navigate]);

  const handleLogin = async (credentials) => {
    setLoading(true);
    setError(null);

    const loginId = (credentials.loginId || credentials.username || '').trim();
    const password = credentials.password || '';

    // Dev fallback bypass check
    if ((loginId === DEV_USERNAME || loginId === 'admin') && password === DEV_PASSWORD) {
      sessionStorage.setItem(DEV_AUTH_KEY, 'true');
      sessionStorage.setItem(LOGIN_ID_KEY, loginId);
      localStorage.setItem(DEV_AUTH_KEY, 'true');
      localStorage.setItem(LOGIN_ID_KEY, loginId);
      setIsAuthenticated(true);
      goToDashboard();
      return;
    }

    // Verhoeff checksum validation - production login IDs must have a valid Verhoeff check digit
    if (!isValidVerhoeff(loginId)) {
      setError('Invalid Login ID: the Verhoeff check digit is incorrect.');
      setLoading(false);
      return;
    }

    try {
      await authService.login(loginId, password);
      sessionStorage.setItem(LOGIN_ID_KEY, loginId);
      localStorage.setItem(LOGIN_ID_KEY, loginId);
      setIsAuthenticated(true);
      goToDashboard();
    } catch (err) {
      const msg = err.response?.data?.message || 'Invalid 12-digit Login ID or password';
      setError(msg);
      setLoading(false);
    }
  };

  return (
    <div className={exiting ? 'login-page login-page-exiting' : 'login-page'}>
      <AppHeader subtitle="Sign in" />
      <LoginForm onSubmit={handleLogin} error={error} loading={loading || exiting} />
    </div>
  );
}

export default LoginPage;

